<template>
  <section class="is-flex">
    <FormMultiSelect
      v-model="filter.operator"
      :config="enumQueryOperatorConfig"
      :show-float-label="false"
      :rules="{ required: true }"
      @select="onQueryOperatorSelect"
      :data-e2e="TableCypressAttribute.filter.inputs.OPERATORS"
    />
    <FormMultiSelect
      v-if="showEnumValueSelectionSelect"
      v-model="value"
      :config="enumSelectionConfig"
      :show-float-label="false"
      :rules="{ required: true }"
      class="m-l-10"
      @select="onEnumValueSelect"
      :data-e2e="TableCypressAttribute.filter.inputs.VALUE_FORM_SELECT"
    />
  </section>
</template>

<script>
import FormMultiSelect from '/@/modules/core/form/components/FormMultiSelect.vue';
import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import { TableFilter } from '/@/modules/core/table/models/TableFilter';
import { UrlQueryOperator } from '/@/modules/core/app/constants/UrlQueryOperator';
import { TableCypressAttribute } from '/@/modules/core/table/constants/TableCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'EnumTableFilter',
  components: { FormMultiSelect },
  props: {
    tableFilter: {
      type: TableFilter,
      required: true
    }
  },
  static: {
    TableCypressAttribute
  },
  data() {
    return {
      filter: this.tableFilter,
      value: null,
      showEnumValueSelectionSelect: false,
      enumQueryOperatorConfig: new FormSelectConfig({
        options: [UrlQueryOperator.EQUAL_TO, UrlQueryOperator.NOT_EQUAL_TO, UrlQueryOperator.IN]
      }),
      enumSelectionConfig: new FormSelectConfig({
        multiple: false,
        options: Object.values(this.tableFilter.column.values)
      })
    };
  },
  computed: {
    isOperatorMultiple() {
      return (
        this.tableFilter.operator === UrlQueryOperator.IN.key ||
        this.tableFilter.operator === UrlQueryOperator.NOT_IN.key
      );
    }
  },
  methods: {
    onQueryOperatorSelect() {
      this.value = null;
      this.tableFilter.setValue(null);
      this.showEnumValueSelectionSelect = false;
      this.enumSelectionConfig.multiple = this.isOperatorMultiple;
      this.$nextTick(() => {
        this.showEnumValueSelectionSelect = true;
      });
    },
    onEnumValueSelect() {
      this.tableFilter.setValue(this.value);
    }
  },
  mounted() {
    this.value = this.tableFilter.value;
    this.showEnumValueSelectionSelect = !!this.value;
  }
};
</script>
